import { FormikProps } from 'formik';
import { useState } from 'react';
import {
    ChannelsInfoWeb,
    ChannelsWebSurvey,
} from '../../../../shared/types/modules/channels-web-information';
import { ToastSwal } from '../../../components/general/toastSwals/toastSwal';

import { asyncCreateChannelsSurvey } from '../../../../services/channels-web.service';
import { CHANNELSMSFORMTHANKYOU } from '../../../../routes/paths';
import { useNavigate } from 'react-router-dom';

export const useChannelWebForm = () => {
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [formikContactPerson, setFormikContactPerson] =
        useState<FormikProps<ChannelsInfoWeb>>();
    const [formikSurvey, setFormikSurvey] =
        useState<FormikProps<ChannelsWebSurvey>>();

    const isValidForm = formikContactPerson?.isValid && formikSurvey?.isValid;

    const handleSubmit = async () => {
        await formikContactPerson?.submitForm();
        await formikSurvey?.submitForm();

        if (!isValidForm) return;

        setLoading(true);
        const data: ChannelsInfoWeb = {
            ...formikContactPerson.values,
            survey: {
                type: 'V1',
                question1: formikSurvey.values.question1 ?? [],
            },
        };

        let res: any | undefined = undefined;

        try {
            res = await asyncCreateChannelsSurvey(data);
        } catch (error) {}

        if (res) {
            ToastSwal.fire({
                text: '¡Felicidades! El formulario se envío satisfactoriamente.',
                icon: 'success',
                timer: 5000,
                position: 'center-end',
            });
            handleClean();
            navigate(CHANNELSMSFORMTHANKYOU, {
                state: {
                    name: formikContactPerson.values.name,
                },
            });
        } else {
            ToastSwal.fire({
                text: `Lo sentimos, no se pudo enviar la informacion del formulario intentelo más tarde`,
                icon: 'error',
                timer: 5000,
                position: 'center-end',
            });
        }

        setLoading(false);
        return res;
    };

    const handleClean = () => {
        formikContactPerson?.resetForm();
        formikSurvey?.resetForm();
    };
    return {
        loading,
        isValidForm,
        handleClean,
        handleSubmit,
        setFormikContactPerson,
        setFormikSurvey,
    };
};
